/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import { useApp } from "../../contexts";
import { FormDatePicker, FormSelect } from "../../components/Form";
import ConnectSocial from "../../components/ConnectSocial";
import { IconUpload } from "../../components/Icons/IconUpload";
import { IconVerified } from "../../components/Icons/IconVerified";
import { phoneCodes } from "../../components/PhoneInputNumber";
import {
  agreePolicy,
  ssoGetUserInfo,
  ssoUpdateProfile,
  uploadFile,
} from "../../services/app";
import * as Notification from "../../Notification";
import * as buffer from "buffer";
import { ModalVerifyPhone } from "./components/ModalVerifyPhone";
import moment from "moment";
import { ModalPolicy } from "../../components/AffiliateComponent/ModalPolicy";

window.Buffer = buffer.Buffer;

const ERROR_DEFAULT = {
  displayName: "",
  email: "",
  bio: "",
  receivedAddress: "",
  baseCcy: "",
};

const EyeMemberBadge = () => {
  return (
    <div className="mb-5">
      <img src="assets/images/eye-member-badge-profile.svg" alt="" />
    </div>
  );
};

export const Profile = () => {
  const { T, user, reloadProfile, getCurrency } = useApp();

  const [formData, $formData] = useState({
    displayName: user.name,
    email: user.email,
    bio: "",
    receivedAddress: "",
    dob: "",
    gender: "",
    baseCcy: getCurrency(),
  });
  const [error, $error] = useState(ERROR_DEFAULT);
  const [avatarUrl, $avatarUrl] = useState(null);
  const [, $bioLength] = useState(150);
  const [countryCode, $countryCode] = useState("US");
  const [phone, $phone] = useState();
  const [verifyPhoneStatus, $verifyPhoneStatus] = useState(true);
  const [showModalVerifyPhone, $showModalVerifyPhone] = useState(false);
  const [state, setState] = useState({
    facebookId: null,
    appleId: null,
    googleId: null,
    instagramId: null,
    password: null,
  });

  const captureAvatar = async (event) => {
    try {
      event.stopPropagation();
      event.preventDefault();
      const file = event.target.files[0];
      if (!validateProfileFileUpload(file)) return;
      const res = await uploadFile(file);
      if (res.data?.data) {
        $avatarUrl(res.data.data);
      } else {
        Notification.error(res?.data?.error?.message ?? T("Something went wrong! Please try again later!"));
      }
    } catch (error) {
      Notification.error(error?.response?.data?.message ?? T("Something went wrong! Please try again later!"));
      console.log("error74 = ", error);
    }
  };

  const validateProfileFileUpload = (file) => {
    if (!file) return false;
    const types = "image/jpeg,image/png,image/gif,image/svg+xml";
    if (!types.includes(file.type)) {
      Notification.error(T("noti.unsupport_file"));
      return false;
    }
    return true;
  }

  const loadUser = async () => {
    reloadProfile();
  };

  const setFormData = (val) => {
    $formData((preVal) => ({ ...preVal, ...val }));
  };

  const updateProfile = () => {
    const info = {
      full_name: formData?.displayName ? formData?.displayName.trim() : "",
      email: formData?.email ? formData?.email.trim() : "",
      avatar: avatarUrl || "",
      baseCcy: formData?.baseCcy ? formData?.baseCcy.trim() : "",
      dob: formData.dob ? moment(formData.dob).format("YYYY/MM/DD") : null,
      gender: formData.gender,
    };

    if (info.full_name.length === 0) {
      $error({ ...error, displayName: T("Display name is require") });
      return;
    }
    if (!info.dob) {
      $error({ ...error, dob: T("birthday_required") });
      return;
    }
    if (!info.gender) {
      $error({ ...error, gender: T("gender_required") });
      return;
    }
    $error(ERROR_DEFAULT);

    ssoUpdateProfile(info).then((res) => {
      if (res?.data?.status) {
        Notification.success(T("Update profile success."));
        loadUser();
      } else if (res?.data?.code === 230) {
        Notification.error(T("error.230"));
      } else
        Notification.error(T(res?.data?.message ?? "Update profile fail."));
    });
  };

  const loadProfile = () => {
    ssoGetUserInfo().then((res) => {
      const data = res.data?.data || {};
      let bio = data?.bio;
      if (!bio) {
        $bioLength(150);
      } else {
        $bioLength(150 - bio.length);
      }
      if (data?.avatar) {
        $avatarUrl(data?.avatar);
      }
      setState({
        facebookId: data.facebook_id,
        appleId: data.apple_id,
        googleId: data.google_id,
        instagramId: data.instagram_id,
        password: data.password_hash,
      });
      $formData({
        displayName: data?.full_name,
        email: data?.email,
        bio: data?.bio,
        receivedAddress: data?.receivedAddress,
        dob: data?.dob ? moment(data?.dob, "YYYY/MM/DD") : "",
        gender: data?.gender,
        baseCcy: getCurrency(),
      });
      if (data?.country_code) {
        $countryCode(data?.country_code);
      }
      if (data?.phone_number) {
        $phone(data?.phone_number);
      }

      if (data?.verify_phone_status) {
        $verifyPhoneStatus(data?.verify_phone_status ? true : false);
      }
    });
  };

  useEffect(() => {
    loadProfile();
  }, []);

  const handleVerifyPhone = () => {
    $showModalVerifyPhone(true);
  };
  const handleChangePhone = () => {
    $showModalVerifyPhone(true);
  };
  const onFinishVerify = (e) => {
    $verifyPhoneStatus(e.verifyPhoneStatus);
    $phone(e.verifyPhone);
    $countryCode(e.countryCode);
    $showModalVerifyPhone(false);
  };
  const onCancelVerify = () => {
    $showModalVerifyPhone(false);
  };

  const handleChangeDoB = (value) => {
    if (moment(value).isValid()) {
      setFormData({ dob: value });
    }
  };

  const hasEyeMemberBadge = user?.eyeMemberLabel;

  const [isOpenModalPolicy, setIsOpenModalPolicy] = useState(false);
  const isConfirmedPolicy = useMemo(
    () => Number(user?.is_agree_policy) === 1 && !!user?.agree_policy_date,
    [user]
  );
  const isAffiliateSource = useMemo(() => {
    const nonAffSources = ["internal_test", "app"];
    return !nonAffSources.includes(user?.source);
  }, [user]);
  const isVerifyPhoneStatus = useMemo(
    () => Boolean(user?.verify_phone_status ?? 0),
    [user]
  );
  const isUpdatedInformation = useMemo(
    () => Boolean(user?.dob && user?.gender && user?.name),
    [user]
  );
  useEffect(() => {
    if (
      !isConfirmedPolicy &&
      isAffiliateSource &&
      isVerifyPhoneStatus &&
      isUpdatedInformation
    ) {
      setIsOpenModalPolicy(true);
    }
  }, [
    isConfirmedPolicy,
    isVerifyPhoneStatus,
    isUpdatedInformation,
    isAffiliateSource,
  ]);
  const [isAgreeing, setIsAgreeing] = useState(false);
  const onConfirmPolicy = async () => {
    try {
      setIsAgreeing(true);
      await agreePolicy();
      setIsOpenModalPolicy(false);
      reloadProfile();
    } catch (error) {
      console.error("Failed to agree policy:", error);
      Notification.error(
        error?.response?.data?.message ??
          T("Something went wrong! Please try again later!")
      );
    } finally {
      setIsAgreeing(false);
    }
  };

  return (
    <Container>
      <ContainerView background="transparent">
        <TitlePage>{T("User Profile")}</TitlePage>
        <div className="flex justify-between items-start w-full mt-[32px] lg:gap-12">
          <div className="w-full block grow-1">
            <div className="lg:flex lg:items-start lg:justify-between lg:flex-row-reverse max-w-[950px]">
              <div className="w-full md:w-auto flex items-center flex-col md:block">
                {hasEyeMemberBadge && <EyeMemberBadge />}
                <label
                  className="flex flex-col items-center justify-center min-w-[175px] w-[175px] h-[175px] 
                  rounded-full bg-white cursor-pointer overflow-hidden mb-7 lg:mb-0"
                >
                  <input
                    type="file"
                    className="hidden"
                    onChange={captureAvatar}
                    accept="image/*"
                  />
                  {avatarUrl && (
                    <img src={avatarUrl} width={175} height={175} alt="" />
                  )}
                  {!avatarUrl && (
                    <>
                      <IconUpload />
                      <p className="text-suzu-gray-7 text-sm text-center mt-2">
                        {T("Upload photo")}
                      </p>
                    </>
                  )}
                </label>
              </div>

              <div className="w-full">
                <div className="lg:flex lg:items-center w-full mb-6 lg:mb-[30px]">
                  <label
                    htmlFor="form_setting_name"
                    className="block text-suzu-gray-9 w-full mb-1 text-[15px] lg:text-base lg:mb-0 lg:min-w-[162px] lg:w-[162px] lg:mr-[33px]"
                  >
                    {T("Display name")} *
                  </label>
                  <div className="p-[1px] rounded-[10px] relative">
                    <input
                      id="form_setting_name"
                      type="text"
                      className="h-[52px] w-full lg:max-w-full lg:w-[486px] px-5 py-3 bg-white rounded-[10px] text-black input-gradient"
                      placeholder={T("Example Name")}
                      value={formData?.displayName || ""}
                      maxLength={100}
                      onChange={(e) =>
                        setFormData({ displayName: e.target.value })
                      }
                    />
                    <div className="bg-mark"></div>
                    {error.displayName && (
                      <p className="absolute left-0 -bottom-5 z-10 text-suzu-error text-sm">
                        {error.displayName}
                      </p>
                    )}
                  </div>
                </div>
                <div className="lg:flex lg:items-center w-full mb-6 lg:mb-[30px]">
                  <label
                    htmlFor="form_setting_email"
                    className="block text-suzu-gray-9 w-full mb-1 text-[15px] lg:text-base lg:mb-0 lg:min-w-[162px] lg:w-[162px] lg:mr-[33px]"
                  >
                    {T("Email")} *
                  </label>
                  <div className="p-[1px] rounded-[10px] relative">
                    <input
                      id="form_setting_email"
                      type="email"
                      className="h-[52px] w-full lg:max-w-full lg:w-[486px] px-5 py-3 bg-white rounded-[10px] text-black input-gradient"
                      placeholder="example@xmail.com"
                      value={formData?.email || ""}
                      disabled
                    />
                    <div className="bg-mark"></div>
                    {error.email && (
                      <p className="absolute left-0 -bottom-5 z-10 text-suzu-error text-sm">
                        {error.email}
                      </p>
                    )}
                  </div>
                </div>
                <div className="lg:flex lg:items-center w-full mb-6 lg:mb-[30px]">
                  <label
                    htmlFor="form_setting_email"
                    className="block text-suzu-gray-9 w-full mb-1 text-[15px] lg:text-base lg:mb-0 lg:min-w-[162px] lg:w-[162px] lg:mr-[33px]"
                  >
                    {T("Date of birth")} *
                  </label>
                  <div className={"relative max-w-full w-full lg:w-[486px]"}>
                    <FormDatePicker
                      allowClear={false}
                      value={formData?.dob}
                      defaultPickerValue={
                        formData?.dob ||
                        moment(new Date()).subtract(18, "years")
                      }
                      format="YYYY/MM/DD"
                      placeholder={T("")}
                      onChange={handleChangeDoB}
                      disabledDate={(current) => {
                        return moment(new Date()) <= current;
                      }}
                    />
                    {error.dob && (
                      <p className="absolute left-0 -bottom-5 z-10 text-suzu-error text-sm">
                        {error.dob}
                      </p>
                    )}
                  </div>
                </div>
                <div className="lg:flex lg:items-center w-full mb-6 lg:mb-[30px] relative">
                  <label
                    htmlFor="form_setting_email"
                    className="block text-suzu-gray-9 w-full mb-1 text-[15px] lg:text-base lg:mb-0 lg:min-w-[162px] lg:w-[162px] lg:mr-[33px]"
                  >
                    {T("Gender")} *
                  </label>
                  <div className={"relative max-w-full w-full lg:w-[486px]"}>
                    <FormSelect
                      allowClear={false}
                      className="w-full"
                      value={formData.gender}
                      onChange={(e) => setFormData({ gender: e })}
                    >
                      <FormSelect.Option value={"male"}>
                        {T("human_male")}
                      </FormSelect.Option>
                      <FormSelect.Option value={"female"}>
                        {T("human_female")}
                      </FormSelect.Option>
                      <FormSelect.Option value={"other"}>
                        {T("Other")}
                      </FormSelect.Option>
                    </FormSelect>
                    {error.gender && (
                      <p className="absolute left-0 -bottom-5 z-10 text-suzu-error text-sm">
                        {error.gender}
                      </p>
                    )}
                  </div>
                </div>
                <div className="lg:flex lg:items-center w-full mb-6 lg:mb-[30px]">
                  <label className="block text-suzu-gray-9 w-full mb-1 lg:mb-0 lg:min-w-[162px] text-[15px] lg:text-base lg:w-[162px] lg:mr-[33px]">
                    {T("Base currency")}
                  </label>
                  <FormSelect
                    allowClear={false}
                    className={"relative max-w-full w-full lg:w-[486px]"}
                    value={formData.baseCcy}
                    disabled
                  >
                    <FormSelect.Option value={"all"}>
                      {T("All")}
                    </FormSelect.Option>
                  </FormSelect>
                </div>
                <div className="flex items-start lg:items-center justify-between w-full mb-6 lg:mb-[30px] lg:justify-start">
                  <label className="text-suzu-gray-9 mb-1 text-[15px] lg:text-base lg:mb-0 lg:min-w-[162px] lg:w-[162px] lg:mr-[33px]">
                    {T("Phone number")}
                  </label>
                  {(!verifyPhoneStatus || !phone) && (
                    <button
                      className="border border-solid border-black/[0.1] rounded-[5px] bg-white h-[30px] px-[10px] text-center"
                      onClick={() => handleVerifyPhone()}
                    >
                      <span className="text-aia-red text-xs">
                        {T("Verify phone")}
                      </span>
                    </button>
                  )}
                  {verifyPhoneStatus && phone && (
                    <div className="flex flex-col items-end gap-4 lg:gap-0 lg:justify-between lg:items-center lg:w-[486px] lg:max-w-full lg:flex-row">
                      <div className="flex items-center gap-2">
                        <p className="text-xs text-black">
                          {phoneCodes[countryCode]} {phone || ""}
                        </p>
                        <IconVerified />
                      </div>
                      <button
                        onClick={() => handleChangePhone()}
                        className={
                          "h-[30px] px-3 py-[2px] bg-white rounded-[5px] border border-solid border-black/[0.1]"
                        }
                      >
                        <span className="text-aia-red text-xs leading-[26px]">
                          {T("Change phone number")}
                        </span>
                      </button>
                    </div>
                  )}
                </div>
                <div className="lg:flex lg:items-center w-full mb-6 lg:mb-[30px]">
                  <label className="block text-suzu-gray-9 w-full mb-4 text-[15px] lg:text-base lg:mb-0 lg:min-w-[162px] lg:w-[162px] lg:mr-[33px]">
                    {T("Connect account")}
                  </label>
                  <ConnectSocial
                    t={T}
                    state={state}
                    loadProfile={() => {
                      loadProfile();
                    }}
                  />
                </div>
                <div className="lg:flex lg:items-center w-full lg:pt-6 pb-[100px]">
                  <div className="min-w-[162px] w-[162px] lg:block mr-[33px]"></div>
                  <button
                    className="bg-black w-[344px] max-w-full block mx-auto lg:mx-0 lg:w-[190px] h-[52px] text-center text-white rounded-[15px]"
                    onClick={updateProfile}
                  >
                    {T("Save")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {showModalVerifyPhone && (
          <ModalVerifyPhone
            handleClickClose={onCancelVerify}
            countryCode={countryCode}
            onFinishVerify={(e) => onFinishVerify(e)}
            type={!verifyPhoneStatus || !phone ? 1 : 2}
          />
        )}
        {isOpenModalPolicy && (
          <ModalPolicy
            onClose={() => setIsOpenModalPolicy(false)}
            handleSubmit={() => onConfirmPolicy()}
            disabled={isAgreeing}
          />
        )}
      </ContainerView>
    </Container>
  );
};
